import React from 'react';
import NavigationComponent from '../../commonComponents/util/NavigationComponent';
import CampaignDetailsListsTable from './CampaignDetailsListsTable';
import CampaignDetailsIndividualsTable from './CampaignDetailsIndividualsTable';
import AddCampaignListModal from './AddCampaignListModal';
import AddCampaignRecipientModal from '../campaignsCommon/AddCampaignRecipientModal';
import { debounce } from 'throttle-debounce';
import { Departments, CurrencyTypes, RecipientTypes } from '../../../lib/systemVariables';
import { getObjectKeyByValue } from '../../../lib/utils';
import { toastr } from 'react-redux-toastr';

export default class CampaignDetailsTable extends NavigationComponent {
  constructor(props) {
    super(props);

    this.state = {
      showModals: {
        addCampaignListModal: false,
        createCampaignListModal: false,
        addCampaignRecipientModal: false,
        createRecipientModal: false
      }
    }

    this.searchDebounce = debounce(500, this.searchDebounce);
    this.searchListsDebounce = debounce(500, this.searchListsDebounce);
  }

  componentWillMount() {
    this.props.actions.getCampaignAllLists(this.props.campaignId);
    this.props.actions.getCampaignAllIndividuals(this.props.campaignId);
    this.props.actions.getIndividuals(this.props.campaignId);
  }

  toggleTable(view) {
    if (this.props.view !== view) {
      this.props.toggleView(view);
    }
  }

  filterLists(event) {
    if (event.target.name === "search") {
      this.props.actions.updateListsTable({ keyword: event.target.value });
      this.searchListsDebounce();
    } else {
        this.props.actions.updateListsTable({ statusFilter: event.target.value });
        this.props.actions.getLists(this.props.campaignId, 1, this.props.listsTable.resultView, this.props.listsTable.sort);
    }
  }

  searchIndividuals(event) {
    this.props.actions.updateIndividualsTable({ search: event.target.value });
    this.searchDebounce();
  }

  searchDebounce() {
    this.props.actions.getIndividuals(this.props.campaignId, 1, this.props.individualsTable.resultView, this.props.individualsTable.sort);
  }

  searchListsDebounce() {
    this.props.actions.getLists(this.props.campaignId, 1, this.props.listsTable.resultView, this.props.listsTable.sort);
  }
  
  async addList(campaignListId, emailMessage, defaultAmount, bypassError) {
    await this.props.actions.addList(this.props.campaignId, campaignListId, emailMessage, defaultAmount, bypassError);
    if (this.props.lists.newList.success) {
      this.props.actions.getLists(this.props.campaignId, 1, this.props.listsTable.resultsView, this.props.listsTable.sort);
      this.props.actions.getCampaignAllLists(this.props.campaignId);
    }
  }

  async verifyExternalUpdates(campaignId, campaignListId, newParticipants, rejectedParticipants,
    defaultAmount, bypassError) {
    await this.props.actions.verifyCampaignListExternalUpdates(campaignId, campaignListId, newParticipants, rejectedParticipants,
      defaultAmount, bypassError);
    if (this.props.lists.verifyUpdates.success) {
      this.props.actions.getLists(this.props.campaignId, 1, this.props.listsTable.resultsView, this.props.listsTable.sort);
      this.props.actions.getCampaignAllLists(this.props.campaignId);
    }
  }

  async addIndividual(bypassError, recipientId, campaignApplication) {
    await this.props.actions.addIndividual(this.props.campaignId, recipientId, bypassError, campaignApplication);
    if (this.props.individuals.newIndividual.success) {
      this.props.actions.getIndividuals(this.props.campaignId, 1, this.props.individualsTable.resultsView, this.props.individualsTable.sort);
      this.props.actions.getCampaignAllIndividuals(this.props.campaignId);
    }
  }

  async removeList(campaignId, campaignListId) {
    await this.props.actions.removeList(campaignId, campaignListId);
    if (this.props.listsTable.removing.success) {
      this.props.actions.getCampaignAllLists(this.props.campaignId);
    }
  }

  async removeIndividual(campaignId, recipientId) {
    await this.props.actions.removeIndividual(campaignId, recipientId);
    if (this.props.individualsTable.removing.success) {
      this.props.actions.getCampaignAllIndividuals(this.props.campaignId);
    }
  }

  async approveIndividualsApplications() {
    await this.props.actions.updateApplicationsStatus('approve', this.props.individualsTable.selected.map(indiv =>
      ({ applicationId: indiv.applicationId, amount: indiv.amount, currency: getObjectKeyByValue(CurrencyTypes, this.props.campaign.isIsraeli ? '₪' : '$') })));

    if (this.props.approvingIndividuals.success) {
      toastr.success(`${this.props.individualsTable.selected.length} ${this.props.individualsTable.selected.length > 1 ? "Applications have" : "Application has"} been approved.`);
      this.props.actions.getIndividuals(this.props.campaignId, this.props.individualsTable.page, this.props.individualsTable.resultsView, this.props.individualsTable.sort);
    } else {
      toastr.error('Something went wrong', `Application${this.props.individualsTable.selected.length > 1 ? "s" : ""} could not be approved.  Please try again.`);
    }
  }

  render() {
    return (
      <div>
        <div className="campaigns-filters">
          <div className="container flex-center flex-justify">
            {(this.props.userPermissions.individuals) ? (
                <ul className="campaign-options flex">
                  <li>
                    <a className={`${this.props.view === "lists" ? "active" : ""} accent-text medium-text`} onClick={this.toggleTable.bind(this, "lists")}>Lists</a>
                  </li>
                  <li>
                    <a className={`${this.props.view === "individuals" ? "active" : ""} accent-text medium-text`} onClick={this.toggleTable.bind(this, "individuals")}>Individuals</a>
                  </li>
                </ul>
              )  : <div />}
            <div className="flex">
              {this.props.view === "lists"
                ? <div className="flex">
                  <div className="search-input" >
                    <i className="material-icons">search</i>
                    <input type="text" placeholder="Search List Names"
                        name="search"
                        value={this.props.listsTable.keyword}
                        disabled={!this.props.listsTable.keyword && !this.props.listsTable.data.records.length}
                        onChange={e => this.filterLists(e)}  />
                  </div>
                  <div className="custom-select">
                    <select value={this.props.listsTable.statusFilter}
                      disabled={!this.props.listsTable.statusFilter && !this.props.listsTable.data.records.length}
                      onChange={e => this.filterLists(e)}>
                      <option defaultValue>All</option>
                      {this.props.campaignListStatuses.map(status => <option key={status.key} value={status.key}>{status.value}</option>)}
                    </select>
                    <i className="icon ion-ios-arrow-down"></i>
                  </div>
                  {(this.props.canUpdate) &&
                    <button className="btn btn-accent2" disabled={this.props.lists.allLists.loading}
                      onClick={this.toggleModal.bind(this, "addCampaignListModal")}>Add List</button>}
                </div>
                : <div className="flex">
                  {this.props.individualsTable.selected.length > 0 && <button className="btn btn-flat btn-small approve"
                    disabled={this.props.approvingIndividuals.loading} onClick={() => this.approveIndividualsApplications()} >
                    <i className="icon ion-ios-checkmark approved-text icon-left large-text middle"></i>
                    {this.props.approvingIndividuals.loading ? "Approving Selected..." : "Approve Selected"}
                  </button>}
                  <div className="search-input">
                    <i className="material-icons">search</i>
                    <input type="text" placeholder="Search" value={this.props.individualsTable.search || ''}
                      disabled={!this.props.individualsTable.search && !this.props.individualsTable.data.records.length}
                      onChange={this.searchIndividuals.bind(this)} />
                  </div>
                  {(this.props.canUpdate) && <button className="btn btn-accent2" disabled={this.props.individuals.allIndividuals.loading}
                    onClick={this.toggleModal.bind(this, "addCampaignRecipientModal")}>Add Recipient</button>}
                </div>
              }
            </div>
          </div>
        </div>
        
        {(this.props.userPermissions.individuals && this.props.view === "lists")
          ? <CampaignDetailsListsTable
            {...this.props.listsTable}
            canUpdate={this.props.canUpdate}
            updateTable={this.props.actions.updateListsTable}
            campaign={this.props.campaign}
            getCampaignLists={(...tableProps) => this.props.actions.getLists(this.props.campaignId, ...tableProps || {})}
            
            update={this.props.actions.updateList}
            updating={this.props.listsTable.updating}
            remove={this.removeList.bind(this)}
            removing={this.props.listsTable.removing}
            canApprove={this.props.canApproveApplications}
            approve={this.props.actions.approveCampaignList}
            approving={this.props.lists.approve}
            resendMessage={this.props.actions.resendExternalCampaignListMessage}
            resendingMessage={this.props.lists.resendMessage}

            //wizard:
            getExternalUpdates={this.props.actions.getCampaignListExternalUpdates}
            externalUpdates={this.props.lists.externalUpdates}
            getReceivingParticipants={this.props.actions.getReceivingParticipants}
            receivingParticipants={this.props.receivingParticipants}
            getExternalListRecipients={this.props.actions.getExternalCampaignListRecipients}
            externalListRecipients={this.props.externalCampaignListRecipients}
            recipientSuggestions={this.props.recipientSuggestions}
            getRecipientSuggestions={this.props.actions.getRecipientSuggestions}
            clearRecipientSuggestions={this.props.actions.clearRecipientSuggestions}
            clearReceivingParticipants={this.props.actions.clearReceivingParticipants}
            verifyExternalUpdates={this.verifyExternalUpdates.bind(this)}
            verifyingUpdates={this.props.lists.verifyUpdates}
            addList={this.addList.bind(this)}
            addingList={this.props.lists.newList}
          />
          : <CampaignDetailsIndividualsTable
            {...this.props.individualsTable}
            canUpdate={this.props.canUpdate}
            canUpdateIndividual={this.props.canUpdateRecipients}
            canUpdateAmount={this.props.canApproveApplications}
            updateTable={this.props.actions.updateIndividualsTable}
            campaign={this.props.campaign}
            getCampaignIndividuals={(...tableProps) => this.props.actions.getIndividuals(this.props.campaignId, ...tableProps || {})}

            update={this.props.actions.updateIndividual}
            updating={this.props.individualsTable.updating}
            remove={this.removeIndividual.bind(this)}
            removing={this.props.individualsTable.removing}
            toggleSelect={this.props.actions.toggleSelectIndividual}
            funds={this.props.funds}
            campaignIndivCategories={this.props.systemSettings.campaignSettings.campaignIndivCategories}
          />}

        <AddCampaignListModal
          show={this.state.showModals.addCampaignListModal}
          close={this.toggleModal.bind(this, "addCampaignListModal")}
          {...this.props.lists.newList}
          isAdmin={this.props.isAdmin}
          addList={this.addList.bind(this)}
          campaign={this.props.campaign}
          getCampaignLists={this.props.actions.getAllCampaignLists}
          campaignLists={{
            ...this.props.campaignLists,
            data: this.props.campaignLists.data
              .filter(list => this.props.lists.allLists.data.map(l => l.campaignListId).indexOf(list.campaignListId) < 0)
              .filter(list => (!this.props.campaign.locationId || list.locationId === this.props.campaign.locationId))
          }}
          hasLists={this.props.listsTable.data.records && this.props.listsTable.data.records.length > 0}
          //create list:
          createList={this.props.actions.createCampaignList}
          creatingList={this.props.creatingCampaignList}
          individualCategories={this.props.systemSettings.recipientSettings.individualTags.map(indivTag => ({ key: indivTag.key, value: indivTag.value }))}
          organizationCategories={this.props.userPermissions.institutions 
            ? this.props.systemSettings.recipientSettings.organizationTags.map(orgTag => ({ key: orgTag.key, value: orgTag.value }))
            : []}
          locations={this.props.locationGroups}
          organizations={this.props.organizations}
          ILFunds={this.props.funds.IL}
          USFunds={this.props.funds.US}
        />

        <AddCampaignRecipientModal
          campaign={this.props.campaign}
          show={this.state.showModals.addCampaignRecipientModal}
          close={this.toggleModal.bind(this, "addCampaignRecipientModal")}
          {...this.props.individuals.newIndividual}
          addRecipient={this.addIndividual.bind(this)}
          funds={this.props.funds}
          defaultUSFund={this.props.systemSettings.fundSettings.defaultUSFund}
          defaultIsraelFund={this.props.systemSettings.fundSettings.defaultIsraelFund}
          recipientType={(this.props.userPermissions.individuals && !this.props.userPermissions.institutions )
            ? RecipientTypes.Individual
              : (this.props.userPermissions.institutions && !this.props.userPermissions.individuals ) 
              ? RecipientTypes.Organization
                : null}
          recipientTypes={this.props.systemSettings.otherSettings.recipientTypes}
          references={this.props.references}
          campaignIndivCategories={this.props.systemSettings.campaignSettings.campaignIndivCategories}
          recipientSuggestions={this.props.recipientSuggestions}
          getRecipientSuggestions={(name, otherInput) => this.props.actions.getRecipientSuggestions(name, {
            ...otherInput,
            applicantType: (this.props.userPermissions.individuals && !this.props.userPermissions.institutions )
              ? RecipientTypes.Individual
                : (this.props.userPermissions.institutions && !this.props.userPermissions.individuals ) 
                ? RecipientTypes.Organization
                  : otherInput ? otherInput.applicantType : undefined,
            locationId: this.props.campaign.locationId,
            departments: [this.props.campaign.isIsraeli ? Departments.IL : Departments.US]
          }, this.props.individuals.allIndividuals.data.map(i => i.recipientId))}
          clearRecipientSuggestions={this.props.actions.clearRecipientSuggestions} />

      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/campaignComponents/campaignDetails/CampaignDetailsTable.jsx